import * as React from "react";
import { Spinner } from "@pfizer/shared/components";
import { cn } from "../../../lib/utils";

export interface PageLoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Custom loading text (defaults to "Loading") */
  text?: string;
}

/**
 * PageLoader - A full-viewport centered loading indicator for page/route transitions.
 *
 * Used as a Suspense fallback for lazy-loaded route components.
 *
 * @example
 * ```tsx
 * <Suspense fallback={<PageLoader />}>
 *   <LazyComponent />
 * </Suspense>
 * ```
 */
function PageLoader({
  className,
  text = "Loading",
  ref,
  ...props
}: PageLoaderProps & { ref?: React.Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      className={cn("grid h-screen w-full place-items-center", className)}
      {...props}
    >
      <div className="flex items-center justify-center">
        <Spinner size="lg" />
        <span className="ml-2 text-xl text-foreground">{text}</span>
      </div>
    </div>
  );
}
PageLoader.displayName = "PageLoader";

export { PageLoader };
